import { IState } from '../../store';

export const selectVillage = (state: IState) => {
  return state.villageData.village;
};
